import script from "./instituteSubscriptionPlans.vue?vue&type=script&setup=true&lang=js"
export * from "./instituteSubscriptionPlans.vue?vue&type=script&setup=true&lang=js"

import "./instituteSubscriptionPlans.vue?vue&type=style&index=0&id=401856a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-401856a7"]])

export default __exports__